import { useEffect, useState } from "react";
import { Check, ChevronsUpDown, UserPlus } from "lucide-react";
import { api } from "@/lib/api";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";

export function PlayerPicker({ player, testId, onChange }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);

  useEffect(() => {
    if (!open || q.length < 2) { setResults([]); return; }
    const t = setTimeout(() => api.get("/players", { params: { q } }).then((r) => setResults(r.data)).catch(() => {}), 250);
    return () => clearTimeout(t);
  }, [q, open]);

  const label = player.create ? `New: ${player.name}` : player.player_name || "Unmatched — pick";
  const pick = (p) => { onChange({ player_id: p.id, player_name: p.name, create: false }); setOpen(false); };
  const options = [...(player.candidates || []), ...results].filter((p, i, arr) => arr.findIndex((x) => x.id === p.id) === i);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button data-testid={testId} className={`flex items-center gap-1 w-44 justify-between rounded border px-2 py-1 text-left ${
          player.player_id || player.create ? "border-slate-700 text-slate-200" : "border-rose-500 text-rose-300"}`}>
          <span className="truncate">{label}</span><ChevronsUpDown className="h-3 w-3 shrink-0 opacity-60" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-72 p-0 bg-[#121722] border-slate-700">
        <Command shouldFilter={false}>
          <CommandInput data-testid={`${testId}-search`} placeholder="Search players…" value={q} onValueChange={setQ} />
          <CommandList>
            <CommandEmpty>No players found.</CommandEmpty>
            <CommandGroup>
              {options.map((p) => (
                <CommandItem key={p.id} value={p.id} onSelect={() => pick(p)}>
                  <Check className={`h-3 w-3 mr-2 ${player.player_id === p.id && !player.create ? "opacity-100" : "opacity-0"}`} />
                  {p.name}<span className="ml-auto text-[10px] text-slate-500">{p.team || ""}</span>
                </CommandItem>
              ))}
              <CommandItem value="__create" data-testid={`${testId}-create`} onSelect={() => { onChange({ create: true, player_id: null, player_name: null }); setOpen(false); }}>
                <UserPlus className="h-3 w-3 mr-2 text-emerald-400" />Create new “{player.name}”
              </CommandItem>
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
